import React from "react"

import { AirtableApi } from "../../helpers/AirtableApi"
import CloudflareBasicStream from "../_base/CloudflareBasicStream"

import { ChildSelector } from "../../helpers/ChildSelector"

import * as cineHeroStyles from "../../styles/beyond_spreadsheet/CineHero.module.css"

export default function CineHero(props) {
  const { content } = props

  const [unlocked, setUnlocked] = React.useState(false)

  const [, forceUpdate] = React.useReducer(x => x + 1, 0)

  const [isSubmitted, setSubmitted] = React.useState(false)
  const [hasError, setHasError] = React.useState(false)

  const [data, setData] = React.useState({
    email: ``,
    firstName: ``,
    lastName: ``,
  })

  const handleItemChange = (evt, cat) => {
    let updated = data
    updated[evt.target.name] = evt.target.value

    setData(updated, forceUpdate())
  }

  const handleSubmit = async evt => {
    evt.preventDefault()

    setHasError(false)

    try {
      await AirtableApi.writeRecord(
        process.env.GATSBY_AIRTABLE_API_TOKEN,
        `appWCo8phhZanoQ9G`,
        `viewers`,
        data,
      )

      setHasError(false)
      setSubmitted(true)
      setUnlocked(true)
    } catch (error) {
      console.error(error)

      setHasError(true)
    }
  }

  const titleWords = ChildSelector.select(
    content,
    `title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )
  const note = ChildSelector.select(
    content,
    `note`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  return (
    <>
      <div className={`row ${props.className} ${cineHeroStyles.wrapper}`}>
        <div className={`col-12 ${cineHeroStyles.innerWrapper}`}>
          <h1>{titleWords}</h1>
          {!unlocked && (
            <form
              className={`row ${cineHeroStyles.form}`}
              onSubmit={handleSubmit}
            >
              <div className={`col ${cineHeroStyles.intro}`}>
                <h1>Insert your information to unlock the movie</h1>

                <div className={`row ${cineHeroStyles.personalInfoWrapper}`}>
                  <div
                    className={`col-sm-12 col-md-12 col-lg-6 ${cineHeroStyles.personalInfo}`}
                  >
                    <label htmlFor="firstName">First Name *</label>
                    <input
                      id="firstName"
                      type="text"
                      className="form-control"
                      name="firstName"
                      value={data.firstName}
                      required
                      onChange={handleItemChange}
                    />
                  </div>
                  <div
                    className={`col-sm-12 col-md-12 col-lg-6 ${cineHeroStyles.personalInfo}`}
                  >
                    <label htmlFor="lastName">Last Name *</label>
                    <input
                      id="lastName"
                      type="text"
                      className="form-control"
                      name="lastName"
                      value={data.lastName}
                      required
                      onChange={handleItemChange}
                    />
                  </div>
                </div>
                <div className={`row ${cineHeroStyles.emailInfo}`}>
                  <div className={`col`}>
                    <label htmlFor="email">Email *</label>
                    <input
                      id="email"
                      type="email"
                      className="form-control"
                      aria-label="Email"
                      name="email"
                      value={data.email}
                      required
                      onChange={handleItemChange}
                    />
                  </div>
                </div>
                <div className={`row ${cineHeroStyles.validation}`}>
                  <div  className={`col`}>
                    <input
                      id="optin"
                      type="checkbox"
                      className="form-check-input"
                      required
                    />
                    <label htmlFor="optin">
                      We would like your permission to reach out to you with
                      more information about our products and services. We will
                      only send you marketing information we think will be
                      relevant to you. We will always treat your personal
                      details with the utmost care and will never sell them to
                      other companies for marketing purposes.
                    </label>
                  </div>
                </div>
                <div className={`row ${cineHeroStyles.submitSection}`}>
                  <div className={`col ${cineHeroStyles.submitBtn}`}>
                    <button type="submit" className={`${cineHeroStyles.btn}`}>
                      Unlock
                    </button>
                    {hasError && (
                      <p>
                        An unexpected error has occurred. Please confirm all
                        data to be correctly input and try again...
                      </p>
                    )}
                    {isSubmitted && (
                      <p>
                        Thank you for your interest! You will receive an e-mail
                        shortly with a follow up.
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </form>
          )}
          {unlocked && (
            <>
              <span className={`${cineHeroStyles.film}`}>
                <CloudflareBasicStream
                  controls={true}
                  autoplay={false}
                  videoStreamId="89ba23159ac601fd1af76cb145a347f0"
                  poster="https://customer-tbynrk1d8u0w65k3.cloudflarestream.com/89ba23159ac601fd1af76cb145a347f0/thumbnails/thumbnail.jpg?time=143s&height=600"
                />
              </span>
              <p className={`${cineHeroStyles.note}`}>{note}</p>
            </>
          )}
        </div>
      </div>
    </>
  )
}
